import React, { Component } from 'react';
import Header from '../components/Header';
import EndChatBtn from '../components/EndChatBtn';
import { auth } from '../services/firebase';
import { db } from '../services/firebase';

import  { Redirect } from 'react-router-dom'

export default class ChatDetail extends Component {
    constructor(props) {
        super(props)
        this.state = {
            user: auth().currentUser,
            partner: this.getPartner(),
            messages: [],
            content: '',
            readError: null,
            writeError: null,
            loadingChats: false,
            isValid: null,
            isActive: true,
        };
        this.getPartner = this.getPartner.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.validateChatId = this.validateChatId.bind(this)
        this.messageForm = this.messageForm.bind(this)
        this.myRef = React.createRef();
    }

    async componentDidMount() {
        this.setState({ readError: null, loadingChats: true });
        const chatArea = this.myRef.current;

        // Listen for new messages
        try {
            db.ref('messages').child(this.props.chatId).on('value', snapshot => {
                let messages = [];
                snapshot.forEach((snap) => {
                    messages.push(snap.val());
                });
                messages.sort(function (a, b) { return a.sentDate - b.sentDate })
                this.setState({ messages });
                chatArea.scrollBy(0, chatArea.scrollHeight);
                this.setState({ loadingChats: false })
            });
        } catch (error) {
            this.setState({ readError: error.message, loadingChats: false });
        }

        // Check chat is active
        db.ref('chats').child(this.props.chatId).child('isActive').on('value', snapshot => {
            if (snapshot.exists() === false) {
                return
            }

            this.setState({ isActive: snapshot.val() });
        });

        this.validateChatId()
    }

    validateChatId() {
        db.ref('user-chats').child(this.state.user.uid).child(this.props.chatId).get().then((snapshot) => {
            this.setState({ isValid: snapshot.exists() });
        });
    }

    handleChange(event) {
        this.setState({
            content: event.target.value
        });
    }

    async handleSubmit(event) {
        event.preventDefault();

        // Return if chat is not active
        if (this.state.isActive === false) {
            return
        }

        this.setState({ writeError: null });
        const chatArea = this.myRef.current;

        // Send message
        try {
            await db.ref('messages').child(this.props.chatId).push({
                text: this.state.content,
                sentDate: Math.floor(Date.now() / 1000),
                senderId: this.state.user.uid,
                senderName: this.state.user.displayName
            });
            await db.ref('chats').child(this.props.chatId).update({
                lastMessage: this.state.content,
                sentDate: Math.floor(Date.now() / 1000),
            });
            this.setState({ content: '' });
            chatArea.scrollBy(0, chatArea.scrollHeight);
        } catch (error) {
            this.setState({ writeError: error.message });
        }
    }

    // Convert Epoch time into a date
    formatTime(timestamp) {
        const d = new Date(timestamp * 1000);
        const time = `${(d.getMonth()+1)}/${d.getDate()} ${d.getHours()}:${d.getMinutes()}`;
        return time
    }

    async getPartner() {
        await db.ref('chats').child(this.props.chatId).get().then((snapshot) => {
            if (snapshot.exists() === false) {
                return
            }

            let chat = snapshot.val()
            var partnerId = null

            let memberIds = Object.keys(chat.members)

            for (var memberId of memberIds) {
                if (memberId !== this.state.user.uid) {
                    partnerId = memberId
                }
            }

            if (partnerId === null) {
                return
            }

            db.ref('users').child(partnerId).get().then((snapshot) => {
                if (snapshot.exists() === false) {
                    return
                }

                this.setState({ partner: snapshot.val() })
            });
        });
    }

    messageForm() {
        if (this.state.isActive === false) {
            let messages = []

            messages.push(`chatId: ${this.state.chatId}`)
            messages.push(`userId: ${this.state.user.uid}`)

            for (let messageData of this.state.messages) {
                let message = `${messageData["sentDate"]}, ${messageData['senderName']}, ${messageData['text']}`
                messages.push(message)
            }

            return (
                <div>
                    <div>This chat has ended.</div>
                    <a
                        href={'data:text/plain;charset=utf-8,' + encodeURIComponent(messages.join('\n'))}
                        download='transcript.txt'
                    >
                        Download Transcript
                    </a>
                </div>
            )
        }

        return (
            <div>
                <form onSubmit={this.handleSubmit}>
                    <textarea className='form-control' name='content' onChange={this.handleChange} value={this.state.content} />
                    {this.state.error ? <p className='text-danger'>{this.state.writeError}</p> : null}
                    <button type='submit' className='btn-submit px-5 mt-4'>Send</button>
                </form>
                <div className='my-3'>
                    <EndChatBtn />
                </div>
            </div>
        )
    }

    render() {
        if (this.state.isValid === false) {
            return <Redirect to='/chat/' />
        }

        return (
            <div>
                <Header />

                <div className='py-5'>
                    <h4 className='mt-4 mx-3'>{this.state.partner.name}</h4>
                </div>

                <div className='chat-area' ref={this.myRef}>
                    {/* loading indicator */}
                    {this.state.loadingChats ? (
                        <div className='spinner-border text-success' role='status'>
                            <span className='sr-only'>Loading</span>
                        </div>
                    ) : "" }
                    {/* chat area */}
                    {this.state.messages.map(message => {
                        return (
                            <div key={message.sentDate} className={'chat-bubble ' + (this.state.user.uid === message.senderId ? 'current-user' : '')}>
                                <p>
                                    {message.text}
                                </p>
                                <span className='chat-time float-right'>
                                    {this.formatTime(message.sentDate)}
                                </span>
                            </div>
                        )
                    })}
                </div>

                {/* message form */}
                <div className='mx-3 my-3'>
                    {this.messageForm()}
                </div>

                <div className='py-5 mx-3'>
                    Loggged in as: <strong className='text-info'>{this.state.user.email}</strong>
                </div>
            </div>
        );
    }
}
